export default function useShowAdmin() {
  // the actual admin functionality is controlled by a hard coded list of guids in studies, this will toggle it but only for selected guids
  const adminParam = new URLSearchParams(window.location.search).get('admin') === 'true';
  return adminParam;
}
